import {
  NewProgressBar,
  toNewProgressBarBackgroundColor,
  toNewProgressBarTextColor,
  toNewProgressBarTextSize,
  toNewProgressBarTheme,
} from "@playlive/overlay-core/progress-bars/new";
import { deepSignal } from "deepsignal";
import { useState } from "preact/hooks";
import DemoAnimationsDropdown from "@/components/overlays/shared/demo-animations-dropdown.jsx";
import ScaledOverlayWrapper from "@/components/overlays/wrapper/scaled-overlay-wrapper.jsx";
import useAdjustableAmounts from "@/hooks/useAdjustableAmounts.js";
import useCommon from "@/hooks/useCommon.js";
import useDemoProgressBarData from "@/hooks/useDemoProgressBarData.js";
import usePreviewAnimations from "@/hooks/usePreviewAnimations.js";
import { isYes } from "@/util/common.js";
import { CHARITY } from "@/util/const.js";
import CustomizeHorizontalProgressBar from "./customize-horizontal-progress-bar.jsx";

const config = deepSignal({
  charityType: CHARITY.TILTIFY,
  textColor: "light-aqua",
  textSize: "medium",
  totalValue: 750,
  goalValue: 1000,
  bgColor: "default-red",
  backgroundOpacity: 100,
  showChallenges: "yes",
  showRewards: "yes",
  showDonors: "yes",
  showScroller: "yes",
  showOriginalGoal: "yes",
  showGoalAmount: "yes",
  donationTimeOffset: 1,
  showAllDonations: "no",
  type: "classic",
  ccamMode: "no",
  ccamFlagHorizontalPosition: "right",
  ccamFlagVerticalPosition: "bottom",
});

const useBetaProgressBars = isYes(import.meta.env.VITE_BETA_PROGRESS_BARS || "no");
const urlBase = useBetaProgressBars ? "progress-bars/new" : "new";

export default function BasicProgressBarPage() {
  const [showMilestones, setMilestones] = useState(false);
  const { currentAmount, goalAmount, setCurrentAmount, setGoalAmount } = useAdjustableAmounts();
  const { overlayInfo, overlayURL, setConfigState, setConfigKeyValue } = useCommon({
    config,
    urlBase,
  });

  const { demoDonations, demoMilestones, demoTargets, demoRewards } =
    useDemoProgressBarData(config);

  const { isPreviewingAnimation, startAnimation } = usePreviewAnimations({
    setMilestones,
    setCurrentAmount,
    setGoalAmount,
  });

  // useEffect(() => {
  //   if (isYes(config.showOriginalGoal)) {
  //     updateAmounts({
  //       newCurrentAmount: 1200,
  //       newGoalAmount: 1500,
  //     });
  //   } else {
  //     updateAmounts({
  //       newCurrentAmount: 750,
  //       newGoalAmount: 1000,
  //     });
  //   }
  // }, [updateAmounts]);

  const progressBarBlock = (
    <NewProgressBar
      className={isYes(config.ccamMode) ? "" : "shadow-2xl"}
      goalAmount={goalAmount}
      originalGoalAmount={1000}
      currentAmount={currentAmount}
      textColor={toNewProgressBarTextColor(config.textColor)}
      textSize={toNewProgressBarTextSize(config.textSize)}
      backgroundColor={toNewProgressBarBackgroundColor(config.bgColor)}
      backgroundOpacity={config.backgroundOpacity}
      completed={false}
      ccamMode={isYes(config.ccamMode)}
      ccamFlagHorizontalPosition={config.ccamFlagHorizontalPosition}
      ccamFlagVerticalPosition={config.ccamFlagVerticalPosition}
      charityType={config.charityType}
      milestones={demoMilestones}
      donations={demoDonations}
      rewards={demoRewards}
      showOriginalGoal={isYes(config.showOriginalGoal)}
      showGoalAmount={isYes(config.showGoalAmount)}
      showChallenges={isYes(config.showChallenges)}
      showRewards={isYes(config.showRewards)}
      showDonors={isYes(config.showDonors)}
      showScroller={isYes(config.showScroller)}
      demoShowMilestones={showMilestones}
      targets={demoTargets}
      type={toNewProgressBarTheme(config.type)}
    />
  );

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col items-center justify-center  overflow-x-hidden">
        <div className="example_overlay relative w-full min-h-40">
          <ScaledOverlayWrapper
            allowScaling={false}
            defaultScale={"scale-100"}
            innerClassName="h-[300px] block"
          >
            {progressBarBlock}
          </ScaledOverlayWrapper>

          <DemoAnimationsDropdown onChosen={startAnimation} disabled={isPreviewingAnimation} />
        </div>

        <CustomizeHorizontalProgressBar
          config={config}
          setConfigKeyValue={setConfigKeyValue}
          setConfigState={setConfigState}
          overlayURL={overlayURL}
          setMilestones={setMilestones}
          overlayName={overlayInfo.name}
          obsDimensions={overlayInfo.obsDimensions}
          setCurrentAmount={setCurrentAmount}
          setGoalAmount={setGoalAmount}
          childrenSlot="appearance"
        ></CustomizeHorizontalProgressBar>
      </div>
    </div>
  );
}
